module.exports = __webpack_public_path__ + "static/media/thePhantomMenace.610d8d1a.jpeg";